import { Flex, Box, Text, Button } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useDollarsTextFromCents from '../../../../../../../hooks/useDollarsTextFromCents';
import { translateModel } from '../../../../../../../utils/translate';
import {
  MEMBER_TIER_EFFECT_TYPE_SINGLE_PURCHASE,
  MEMBER_TIER_EFFECT_TYPE_WITHIN_INTERVAL,
} from '../../../constants/memberTiers';
import { useProfileContext } from '../../../context/profileContext';
import ProgressBar from '../components/ProgressBar';
import { memberTierRuleType } from '../../../propTypes';
import { getExtendProgressPercentage } from '../utils';

const PERCENTAGE_HUNDRED = 100;

const MemberExtendBalance = ({
  extendBalanceStatusWording = '',
  extendRule,
}) => {
  const { userData } = useProfileContext();
  const { t, i18n } = useTranslation();
  const getDollarsTextFromCents = useDollarsTextFromCents();

  const membershipTier = userData.membership_tier;
  const membershipTierGap = userData.membership_tier_gap;

  const extendBalanceInfo = useMemo(() => {
    if (!extendRule) {
      return {};
    }

    return {
      extendType: extendRule?.condition_interval.type,
      progressPercentage: getExtendProgressPercentage(membershipTierGap),
      currentSpending: getDollarsTextFromCents(
        membershipTierGap.user_spendings_for_extend ?? 0,
      ),
    };
  }, [extendRule, getDollarsTextFromCents, membershipTierGap]);

  return extendRule ? (
    <Box textAlign="left">
      <Flex
        justifyContent="flex-start"
        marginBottom="10px"
        className="member-center-profile-section_title"
      >
        <Box fontSize="15px" color="#dddddd" marginRight="10px">
          <i
            className="fa fa-flag member-center-profile__section-title-icon"
            aria-hidden="true"
          ></i>
        </Box>
        <Text
          flex="1"
          variant="sectionTitle"
          className="member-center-profile__section-title-text"
        >
          {t('users.membership.tier.extend', {
            tier: translateModel(
              membershipTier.name_translations,
              i18n.language,
            ),
          })}
        </Text>
      </Flex>
      {extendBalanceInfo.extendType ===
        MEMBER_TIER_EFFECT_TYPE_WITHIN_INTERVAL && (
        <>
          <Flex justifyContent="space-between" marginBottom="5px">
            <Text
              variant="description"
              className="member-center-profile__description-text"
            >
              {extendBalanceInfo.currentSpending}
            </Text>
            <Text
              variant="description"
              className="member-center-profile__description-text"
            >
              {extendBalanceStatusWording}
            </Text>
          </Flex>
          <ProgressBar percentage={extendBalanceInfo.progressPercentage} />
        </>
      )}
      {extendBalanceInfo.extendType ===
        MEMBER_TIER_EFFECT_TYPE_SINGLE_PURCHASE && (
        <div>
          <Text
            variant="description"
            className="member-center-profile__description-text"
            display="inline"
            verticalAlign="middle"
          >
            {extendBalanceStatusWording}
          </Text>
          {extendBalanceInfo.progressPercentage !== PERCENTAGE_HUNDRED && (
            <Button
              display="inline"
              variant="textButton"
              className="member-center-profile__text-button"
              onClick={() => window.open('/')}
            >
              {t('users.membership.tier.upgrade.condition.continue')}
            </Button>
          )}
        </div>
      )}
      <Text
        variant="progressBarHint"
        className="member-center-profile__hint-text"
        marginTop="5px"
      >
        {t('users.membership.tier.extension.date.description')}
      </Text>
    </Box>
  ) : null;
};

MemberExtendBalance.propTypes = {
  extendBalanceStatusWording: PropTypes.string,
  extendRule: memberTierRuleType,
};

export default MemberExtendBalance;
